<template>
    <article class="item-card">
        <nuxt-link class="image-holder" :to="to" v-test:imageHolder>
            <lazy-background
                :src="image.src"
                :alt="name"
            >
                <markdown-content
                    v-if="note"
                    :content="note"
                    v-test:note
                />
            </lazy-background>
        </nuxt-link>
        <div class="textual-content">
            <strong class="name" v-test:name>
                {{ name }}
            </strong>
            <p v-if="description" class="description" v-test:description>
                {{ description }}
            </p>
            <b-button
                variant="primary"
                size="sm"
                :to="to"
                v-test:btn
            >
                {{ $snippet('explore', 'explore') }} <span class="sr-only">{{ name }}</span>
            </b-button>
        </div>
    </article>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';

    export default {
        name: 'item-card',

        components: { MarkdownContent },

        props: {
            image: {
                type: Object,
                default: () => ({}),
            },

            name: {
                type: String,
                required: true,
            },

            description: {
                type: String,
                default: '',
            },

            to: {
                type: String,
                required: true,
            },

            note: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .item-card {
        color: primary-palette(2);
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .image-holder {
        display: block;
        transition: filter 0.3s;
        margin-bottom: 17px;
        background-color: secondary-palette(7);
        border-radius: 30px;
        overflow: hidden;

        &:hover,
        &:focus-visible,
        &:active {
            filter: brightness(0.85);
        }
    }

    .lazy-background {
        position: relative;
        padding-bottom: 110%;
        @include media-breakpoint-up(md) {
            padding-bottom: 117%;
        }
    }

    .textual-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .markdown-content {
        position: absolute;
        right: 18px;
        bottom: 20px;
        display: inline-block;
        padding: 4px 17px;
        color: secondary-palette(8);
        background-color: secondary-palette(1);
        border-radius: $btn-border-radius;

        ::v-deep p {
            margin-bottom: 0;
        }
    }

    .name {
        display: block;
        font-size: rem(32px);
        line-height: rem(34px);
    }

    .description {
        display: block;
        font-size: rem(20px);
        line-height: rem(24px);
        margin-bottom: 0;
    }

    .btn {
        margin-top: 5px;
    }
</style>
